import React from 'react';
import { useTranslation } from 'react-i18next';
import { Hero, QuickLinks, UnderDev } from '../blocks/all-blocks';
import '../styles/creations.css';

const Me = ({ transfile }) => {
  const { t } = useTranslation();

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.travel'), url: '/travel' },
    { name: t('quickLinks.notes'), url: '/notes' }
  ];

  return (
    <div className="cont-body">
      <Hero translation={transfile}/>
      <UnderDev />
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default Me;